import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { SeekingStatus } from '@xing-com/crate-common-graphql-types';
import { Headline } from '@xing-com/typography';

import {
  StyledHeadline,
  StyledIllustration,
  StyledOption,
} from './job-status.styled';

type JobStatusProps = {
  onJobSearchSelect: (seekingStatus: SeekingStatus) => void;
};

export const JobStatus: React.FC<JobStatusProps> = ({ onJobSearchSelect }) => {
  const handleSeekingStatusClick = (seekingStatus: SeekingStatus): void => {
    onJobSearchSelect(seekingStatus);
  };

  return (
    <>
      <StyledHeadline size="large" sizeConfined="xxlarge">
        <StyledIllustration size="small" />
        <FormattedMessage id="CRATE_VITA_PREFERENCES_STATUS_TITLE" />
      </StyledHeadline>
      <Headline size="medium" sizeConfined="large">
        <FormattedMessage id="CRATE_VITA_PREFERENCES_STATUS_SUBLINE" />
      </Headline>
      <StyledOption
        name="status"
        onClick={() => handleSeekingStatusClick(SeekingStatus.Seeking)}
      >
        <FormattedMessage id="CRATE_VITA_PREFERENCES_STATUS_SEEKING" />
      </StyledOption>
      <StyledOption
        name="status"
        onClick={() => handleSeekingStatusClick(SeekingStatus.Interested)}
      >
        <FormattedMessage id="CRATE_VITA_PREFERENCES_STATUS_INTERESTED" />
      </StyledOption>
      <StyledOption
        name="status"
        onClick={() => handleSeekingStatusClick(SeekingStatus.NotSeeking)}
      >
        <FormattedMessage id="CRATE_VITA_PREFERENCES_STATUS_NOT_SEEKING" />
      </StyledOption>
    </>
  );
};
